import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {ProjectMigration} from './contracts'

export async function apiAcknowledgeMigrationCompletion(): Promise<ProjectMigration> {
  const apiMetadata = getApiMetadata('memex-migration-acknowledge-completion-api-data')
  const {data} = await fetchJSON<ProjectMigration>(apiMetadata.url, {
    method: 'POST',
    token: apiMetadata.token,
  })

  return data
}
